import api from './api';

function dataset(response) {
  const body = response?.data;
  if (!body || body.error === true || (body.code != null && Number(body.code) !== 200) || body.dataset == null) {
    throw new Error(body?.message || 'Unable to process reviews. Please try again.');
  }
  return body.dataset;
}

export async function fetchAppReviews(page = 1, signal) {
  const result = dataset(await api.get('/get-app-reviews', { params: { page }, signal }));
  if (!result.data || !Array.isArray(result.data.reviews)) {
    throw new Error('Unable to load reviews. Please try again.');
  }
  return result.data;
}

export async function postAppReview({ rating, review }) {
  return dataset(await api.post('/post-app-review', { rating: String(rating), review }));
}
